import { PageConstant } from './../../../constant/page.constant';
import { SpriteConstant } from './../../../constant/sprite.constant';
import { UtilService } from 'src/app/util/UtilService';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class TableLimitsLayoutComponent implements OnInit, OnChanges {
  private resizeTimeOut;
  @Input() data: any;
  @Input() currentLanguage = 'en';
  @Input() userCurrency: any = 'USD';
  betLimits: any;
  liveDealerLimitgameDetailsArr: any;
  currencySymbol: string;
  public state;
  _subscriptionScale;

  public contentHeight = 0;
  @Output() eventEmit: EventEmitter<any> = new EventEmitter<any>();
  selectedBets: Array<boolean> = [];

  common_icons: any;
  menu_icons: any;
  lang_icons: any;

  version = '';

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }
  constructor(
    public firebaseAnalyticsServices: FirebaseAnalyticsService,
    public _utilService: UtilService
  ) {
    this.setContentHeight();
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subKKKKKKscriptionScale');
      this.resizeTimeOut = setTimeout(() => {
        this.setContentHeight();
        window.clearTimeout(this.resizeTimeOut);
        delete this.resizeTimeOut;
      }, 300);
    });
  }

  setContentHeight = () => {
    //console.log('setContentHeight setContentHeight setContentHeight setContentHeight');
    this.contentHeight =
      this._utilService.parentHeight != 0
        ? this._utilService.parentHeight
        : window.innerHeight;
    // console.log(this.contentHeight);
  };

  ngOnInit() {
    this.init();
    this.version = PageConstant.VERSION;
  }

  ngOnChanges(changeData) {
    if (changeData.data) {
      this.data = changeData.data.currentValue;
      this.init();
    }
  }

  init() {
    this.betLimits = this.data.betLimits;
    if (this.betLimits == undefined) return;
    this.liveDealerLimitgameDetailsArr =
      this.data.liveDealerLimitgameDetailsArr;

    this.menu_icons = SpriteConstant.MENU_ICONS;
    this.lang_icons = SpriteConstant.LANG_ICONS(
      this._utilService.currentLanguage
    );
    this.common_icons = SpriteConstant.COMMON_ICONS;
    this.currencySymbol = this.data.currencySymbol;
    const len = this.betLimits.length;
    for (let i = 0; i < len; i++) {
      this.selectedBets.push(false);
    }
  }

  buttonOverOrOut(value) {
    //console.log(value);
    const len = this.selectedBets.length;
    for (let i = 0; i < len; i++) {
      if (i !== value) {
        this.selectedBets[i] = false;
      }
    }
    this.selectedBets[value] = !this.selectedBets[value];
  }

  buttonClick(value) {
    //console.log(value);
    //console.log(this.betLimits[value].betlimitid);
    /*this.firebaseAnalyticsServices.sendAction(FirebaseConstant.FC21LCDesktop['playnownewtable'].eventAction,
      FirebaseConstant.FC21LCDesktop['playnownewtable'].category,
      FirebaseConstant.FC21LCDesktop['playnownewtable'].eventId,
      FirebaseConstant.FC21LCDesktop['playnownewtable'].catId,
      FirebaseConstant.FC21LCDesktop['playnownewtable'].Label);*/
    /*'Click', 'FC21Tables / FCBTables Desktop',  'BetLimitType_NewTable', this.data.title*/
    let tableLimitObj: any = {};
    tableLimitObj.status = 'launchGame';
    if (this.data.gameTableName == 'LiveCasino') {
      tableLimitObj.betlimitid = this.betLimits[value].betlimitid;
      tableLimitObj.gameTableName = this.data.gameTableName;
      this.eventEmit.emit(tableLimitObj);
    } else if (this.data.gameTableName == 'livedealer') {
      tableLimitObj.betlimitid = this.betLimits[value].betlimitid;
      tableLimitObj.gameTableName = this.data.gameTableName;
      tableLimitObj.liveDealerLimitgameDetailsArr =
        this.data.liveDealerLimitgameDetailsArr;
      this.eventEmit.emit(tableLimitObj);
    }
  }

  onCloseClick = (event = null) => {
    let tableLimitObj: any = {};
    tableLimitObj.status = 'close';
    this.eventEmit.emit(tableLimitObj);
  };
  ngOnDestroy(): void {
    if (this.resizeTimeOut) {
      window.clearTimeout(this.resizeTimeOut);
    }
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
    delete this.resizeTimeOut;
  }
}
